






































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { ReferralAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'
import { ReferralStatus } from '@/api/types'
import { isAllowedUserForReferral } from '@/helpers/security'

@Component
export default class RecentReferralsBlock extends Vue {
    loading: boolean = false
    referrals: Referral[] = []
    orderBy: string = 'createdAt'
    view: string = 'user'

    mounted() {
        this.view = this.$currentUser.defaultDashboardView
        this.loadReferrals()
    }

    get availableOrderBy(): string[] {
        return ['createdAt', 'updatedAt', 'successfulAt', 'unsuccessfulAt']
    }

    get availableOrderByOptions() {
        return this.availableOrderBy
            .map(availableOrderBy => ({
                label: this.$t(`dashboard.recent-referrals.orderBy.${availableOrderBy}`),
                value: availableOrderBy,
            }))
    }

    changeOrderBy(orderBy: string): void {
        if (!this.availableOrderBy.includes(orderBy)) {
            return
        }

        this.orderBy = orderBy
    }

    get availableViews(): string[] {
        return this.$currentUser.isTeamLead ? ['user', 'branches'] : ['user']
    }

    get availableViewsOptions() {
        return this.availableViews
            .map(availableView => ({
                label: this.$t(`dashboard.recent-referrals.view.${availableView}`),
                value: availableView,
            }))
    }

    changeView(view: string): void {
        if (!this.availableViews.includes(view)) {
            return
        }

        this.view = view
    }

    @Watch('orderBy')
    @Watch('view')
    async reloadReferrals() {
        let scrollTop = null

        let element = this.$el
        while (element.parentElement) {
            element = element.parentElement
            if (element.scrollTop > 0) {
                scrollTop = element.scrollTop
                break
            }
        }

        await this.loadReferrals()

        if (scrollTop) {
            element.scrollTop = scrollTop
        }
    }

    async loadReferrals(): Promise<void> {
        const params = {
            pagination: true,
            page: 1,
            itemsPerPage: 10,
            view: this.view + '_in',
        }
        params[`order[${this.orderBy}]`] = 'desc'

        this.loading = true
        const result = await ReferralAPI.getPaged(params)
        this.referrals = result.collection
        this.loading = false
    }

    routeToDetail(referral: Referral) {
        if (!isAllowedUserForReferral(this.$currentUser, referral) && this.$currentUser.betaOptInEnabled) {
            return {
                name: 'one_contact_detail',
                params: {
                    contactId: referral.contact.id,
                    toOne: this.$currentUser.betaOptInEnabled,
                },
            }
        }

        return {
            name: 'tasks_detail',
            params: {
                referralId: referral.id,
                contactId: referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }

    colorForStatus(status: string, opacity: number = 1): string {
        const colors = {
            open: `rgba(96, 96, 96, ${opacity})`,
            [ReferralStatus.NEW]: `rgba(19, 210, 197, ${opacity})`,
            [ReferralStatus.UNREACHABLE]: `rgba(235, 89, 140, ${opacity})`,
            [ReferralStatus.PENDING]: `rgba(247, 131, 35, ${opacity})`,
            [ReferralStatus.APPOINTMENT]: `rgba(66, 153, 225, ${opacity})`,
            [ReferralStatus.PROPOSAL]: `rgba(145, 105, 226, ${opacity})`,
            [ReferralStatus.ON_HOLD]: `rgba(231, 220, 30, ${opacity})`,
            [ReferralStatus.SUCCESSFUL]: `rgba(0, 163, 137, ${opacity})`,
            [ReferralStatus.CLOSED]: `rgba(222, 64, 119, ${opacity})`,
            [ReferralStatus.PROCESSED]: `rgba(169, 50, 38, ${opacity})`,
        }

        return colors[status]
    }
}
